import React from "react";
import { isValid, parseISO } from "date-fns";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { BsFillInfoSquareFill } from "react-icons/bs";
import CPF from "../../Formatters/CPF";
import DateTime, { formatarData } from "../../Formatters/DateTime";

const writeTemplate = (data, template) => {
  /** Na raiz do template: string, data válida ou função que retorne componente */
  const keys = Object.keys(template);

  if (!keys.length) return null;

  return keys.map((key) => {
    const val = template[key];
    if (!val) return null;

    // Datas
    if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(val) && isValid(parseISO(val))) {
      return (
        <p key={key}>
          <b>{key}</b>
          {formatarData(val, "dd/MM/yyyy HH:MM")}
        </p>
      );
    }

    // Funções
    if (typeof template[key] === "function") {
      return (
        <p key={key}>
          <b>{key}</b>
          {template[key](data, template)}
        </p>
      );
    }

    // Strings (fallback)
    return (
      <p key={key}>
        <b>{key}</b>
        {template[key]}
      </p>
    );
  });
};

const defaultTemplate = (codigo, data) => ({
  // "Código: ": `${codigo}`,
  "Inclusão: ": (
    <>
      <br />
      {data?.documentoInclusao === "DEVELOPER" || data?.documentoInclusao === "AUD02" ? (
        data?.documentoInclusao
      ) : (
        <CPF value={data?.documentoInclusao} />
      )}
      <br />
      {data?.nomeFormalInclusao}
      <br />
      <DateTime value={data?.dataInclusao} stringFormat="dd/MM/yyyy HH:mm:ss" />
    </>
  ),
  "Última Alteração: ":
    !codigo && !data?.documentoAlteracao ? (
      <>
        <br />
        Sem Alterações
      </>
    ) : (
      <>
        <br />
        {data?.documentoAlteracao === "DEVELOPER" || data?.documentoAlteracao === "AUD02" ? (
          data?.documentoAlteracao
        ) : (
          <CPF value={data?.documentoAlteracao} />
        )}
        <br />
        {data?.nomeFormalAlteracao}
        <br />
        <DateTime value={data?.dataAlteracao} stringFormat="dd/MM/yyyy HH:mm:ss" />
      </>
    ),
});

const OverlayInfoAdicional = (props) => {
  const { data, keyFieldName, template } = props;

  if (!data || !Object.keys(data).length) return null;

  let codigo = null;

  /* Primeira propriedade via de regra é o código.
     Use 'key' se objeto desrespeita essa convenção. */
  if (keyFieldName) codigo = data[keyFieldName];
  if (!codigo && !keyFieldName) codigo = data[Object.keys(data)[0]];

  // if (!codigo) return null;

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <p>
          <b>Informações Adicionais</b>
        </p>
        {writeTemplate(data, template || defaultTemplate(codigo, data.data))}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={popover}>
      <Button variant="bg-transparent" className="btn-lg text-primary pa-0 p-0">
        <BsFillInfoSquareFill />
      </Button>
    </OverlayTrigger>
  );
};

export default OverlayInfoAdicional;
